import { render, staticRenderFns } from "./CardAIQuestions.vue?vue&type=template&id=18bc9c0e&scoped=true&"
import script from "./CardAIQuestions.vue?vue&type=script&lang=ts&"
export * from "./CardAIQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./CardAIQuestions.vue?vue&type=style&index=0&id=18bc9c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc9c0e",
  null
  
)

export default component.exports